import { PropsWithChildren } from 'react';
import ReactModal from 'react-modal';
import { useModal } from '../../contexts/modal';
import * as UI from './styles';

type ModalProps = {
    isOpen?: boolean
}

const style: React.CSSProperties | undefined = {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 600,
    maxWidth: '90%',
    maxHeight: '90%'
}

const Modal = ({ children, isOpen }: PropsWithChildren<ModalProps>) => {
    const { hide } = useModal();

    return (
        <ReactModal
            isOpen={!!isOpen}
            contentLabel="Minimal Modal Example"
            onRequestClose={hide}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="modal-custom"
            portalClassName='react-modal'
            parentSelector={() => document.getElementById('root') ?? document.body}
            style={{ content: style }}
        >
            <UI.Container>
                {children}
            </UI.Container>
        </ReactModal>
    );
}

export default Modal;